<template>
    <div class="col-12 mt-4">
        <div class="card border-0 w-100">
            <div class="card-body border rounded-top px-4">
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <h2>Transport methods</h2>
                        <div class="mediums mt-3">
                            <div class="mediums">
                                <div v-for="(icon, index) in getIconNamesByStage('depart')" :key="index" class="medium text-center d-inline-block mr-3">
                                        <svg-icon :name="icon" width="auto" height="1.5em"></svg-icon>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <div class="row">
                        <h2> Outbound journey </h2>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-8 d-flex">
                                        <div class="indicator-item d-inline-block pr-1 col-4">
                                            <p>Depart at:</p>
                                            <h2 class="text-primary">{{ journey[showingJourneyType].departure_at }}</h2>
                                        </div>
                                        <div class="time text-center flex-grow-1 ml-3">
                                            <p class="d-inline-block">Time</p>
                                            <svg-icon name="dotted-line-lg" class="w-100" width="auto"></svg-icon>
                                            <p><strong>{{ duration.format("h[hrs] m[m]") }}</strong></p>
                                        </div>
                                    </div>
                                    <div class="col-4 text-left">
                                        <div class="indicator-item d-inline-block pr-1">
                                            <p>Arrive at:</p>
                                            <h2 class="text-primary">{{ journey[showingJourneyType].arrival_at }}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-n2">
                                    <div class="col-4">
                                        <span>From:</span>
                                        <p>
                                            <strong>
                                                {{ origin }}
                                            </strong>
                                        </p>
                                    </div>
                                    <div class="col-4"></div>
                                    <div class="col-4">
                                        <span>To:</span>
                                        <p>
                                            <strong>
                                                {{ destination }}
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                             <div class="col-8 my-3" style="text-align: right">
                                 <hr>
                            </div>
                        </div>
                    </div>
                 </div>
                <!-- return journey -->
                 <div v-if="this.showingReturn" id="return-section">
                    <div class="row">
                        <div class="col-md-3 col-sm-12">
                            <div class="mediums mt-3">
                                <div class="mediums">
                                    <div v-for="(icon, index) in getIconNamesByStage('return')" :key="index" class="medium text-center d-inline-block mr-3">
                                        <svg-icon :name="icon" width="auto" height="1.5em"></svg-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9 col-sm-12">
                            <div class="row">
                            <h2> Return journey </h2>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-8 d-flex">
                                            <div class="indicator-item d-inline-block pr-1 col-4">
                                                <p>Depart at:</p>
                                                <h2 class="text-primary">{{ journey.return.departure_at }}</h2>
                                            </div>
                                            <div class="time text-center flex-grow-1 ml-3">
                                                <p class="d-inline-block">Time</p>
                                                <svg-icon name="dotted-line-lg" class="w-100" width="auto"></svg-icon>
                                                <p><strong>{{ returnDuration.format("h[hrs] m[m]") }}</strong></p>
                                            </div>
                                        </div>
                                        <div class="col-4 text-left">
                                            <div class="indicator-item d-inline-block pr-1">
                                                <p>Arrive at:</p>
                                                <h2 class="text-primary">{{ journey.return.arrival_at }}</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-n2">
                                        <div class="col-4">
                                            <span>From:</span>
                                            <p>
                                                <strong>
                                                    {{ destination }}
                                                </strong>
                                            </p>
                                        </div>
                                        <div class="col-4"></div>
                                        <div class="col-4">
                                            <span>To:</span>
                                            <p>
                                                <strong>
                                                    {{ origin }}
                                                </strong>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               <!-- end of return -->

                <div class="col-12 my-3">
                                <div class="row">

                                </div>
                                <div class="row mt-4">
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Estimated return time:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                                <strong>{{ return_time.format("h[hrs] m[m]") }}</strong>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Estimated walking distance:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                                <strong>{{ total_walking_distance }} miles</strong>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Estimated wait time:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                                <strong>{{ total_wait_time.format("h[hrs] m[m]") }}</strong>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Departure from hospital:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                            <strong>{{ journey.return.departure_at }}</strong>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Gradient:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                                <strong>108ft 0ft</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="row">
                                            <div class="col-8">
                                                <p class="d-inline-block">Estimated traffic:</p>
                                            </div>
                                            <div class="col-4 text-right">
                                                <strong>Busy</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            </div>
            <div class="card-footer text-muted border-0 text-right purple-background">
                <h1 class="text-primary">Total estimated cost: {{ total_estimated_cost }}</h1>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    props: ['journey', 'type', 'showingReturn'],
    data() {
        return {
            showingJourneyType: 'depart',
        }
    },
    computed: {
        ...mapGetters([
            'getIconNamesByStage',
        ]),
        duration() {
            return moment.duration(this.journey[this.showingJourneyType].duration.value, 'seconds')
        },
        returnDuration() {
            return moment.duration(this.journey.return.duration.value, 'seconds')
        },
        return_time() {
            return moment.duration(this.journey.return.duration.value, 'seconds')
        },
        wait_time() {
            return moment.duration(this.journey[this.showingJourneyType].wait_time, 'seconds')
        },
        destination() {
            return this.showingJourneyType === 'depart' ? this.journey.destination : this.journey.origin
        },
        origin() {
            return this.showingJourneyType === 'depart' ? this.journey.origin : this.journey.destination
        },
        total_wait_time() {
            const totalWaitTime = this.journey.depart.wait_time + this.journey.return.wait_time
            return moment.duration(totalWaitTime, 'minutes')
        },
        total_walking_distance() {
            const totalWalkingDistance = this.journey.return.walking_distance.value + this.journey.depart.walking_distance.value
            return _.round(totalWalkingDistance * 0.00062137, 2)
        },
        total_estimated_cost() {
            return this.journey.cost
        },
    },
}
</script>
<style>

</style>
